import DynamicImageCard from '../components/dynamicImageCard'

class DynamicImageCards {
	components: DynamicImageCard[] = []

	init(container: Document | HTMLElement = document): void {
		container.querySelectorAll<HTMLElement>('.hg-dynamic-image-cards').forEach((el) => {
			const component = new DynamicImageCard(el)
			component.init()
			this.components.push(component)
		})
	}

	update(container: Document | HTMLElement = document): void {
		this.cleanup()
		this.init(container)
	}

	cleanup(): void {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new DynamicImageCards()
